import { render, staticRenderFns } from "./StoresList.vue?vue&type=template&id=5b90bfdb&scoped=true&"
import script from "./StoresList.vue?vue&type=script&lang=js&"
export * from "./StoresList.vue?vue&type=script&lang=js&"
import style0 from "./StoresList.vue?vue&type=style&index=0&id=5b90bfdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b90bfdb",
  null
  
)

export default component.exports